import {
  i
} from "./chunk.775UL347.js";

// src/components/jb-contact-overlay/jb-contact-overlay.css.ts
var jb_contact_overlay_css_default = i`.sr-only{block-size:1px;border:0;clip:rect(0, 0, 0, 0);inline-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute}:host{background-color:#fff;display:block;min-height:100%;padding-bottom:126px;padding-top:42px}@media(min-width: 600px){:host{padding-top:12px}}@media(min-width: 1281px){:host{padding-top:2px}}:host{--jb-form-block-padding: var(--theme-spacing-between-components-small)}iframe{border:0;height:0;width:100%}`;

export {
  jb_contact_overlay_css_default
};
